
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import CPOpenAccountFormProse from '../open-account/form/CPOpenAccountFormProse.vue';
import { CPButton } from '@capital-platforms/cpui';
import { ReminderSkipLimit } from '@/store/dueDiligence/constants';
import { DueDiligenceEmailType } from '@/utils/emailTypes';
import { validate } from '@/validation';
import { GeneralDetailsSchema, SourceSchema } from '@/store/dueDiligence/schema';
import { USER_ROLES } from '@/utils/roles';

@Component({
    components: {
        CPOpenAccountFormProse,
        CPOpenAccountFormSubsection,
        CPButton
    }
})
export default class CPDueDiligenceIntroduction extends Vue {
    get isLoading(): boolean {
        return this.$store.state.dueDiligence.isLoading;
    }

    get canSkip(): boolean {
        return this.$store.state.dueDiligence.reminder.SkipCount < ReminderSkipLimit;
    }

    get clientBostonId(): number | null | undefined {
        return this.$store.state.dueDiligence.clientBostonId ?? this.$store.state.account.details.bostonId;
    }

    async proceed() {
        const roles = this.$store.state.account.details.role;
        if (!this.validateGeneralDetails()) {
            return;
        }

        if (!this.validateSourceOnly()) {
            return;
        }

        const request = { ...this.$store.state.dueDiligence.details, ConsultantBostonId: Number(this.$store.state.account.details.bostonId), ClientBostonId: Number(this.clientBostonId), EmailType: DueDiligenceEmailType.ClientSubmissionAdjusted }

        await this.$store.dispatch('dueDiligence/updateUserDetails',
            request);
        this.$store.dispatch('dueDiligence/toggleIntroductionModal');

        if (
            roles.includes(USER_ROLES.CONSULTANT) ||
            roles.includes(USER_ROLES.WHITELABEL_ADMIN)
        ) {
            await this.$store.dispatch('dueDiligence/getDueDiligenceList');
        }
    }

    async reminderMeLater() {
        await this.$store.dispatch('dueDiligence/skipUserReminder',
            this.clientBostonId
        );
    }

    private validateGeneralDetails(): boolean {
        const dueDiligence = this.$store.state.dueDiligence;
        const generalDetails = dueDiligence.details.GeneralDetails;
        const accountType = generalDetails?.PlatformAccount?.PlatformAccountType;
        const result = GeneralDetailsSchema(dueDiligence.fiscalResidenceChanged).validate(generalDetails, {
            abortEarly: false,
            context: {
                accountType
            }
        });

        if (result.error) {
            this.$store.commit(
                'addError',
                'Please complete all required General Details before continuing.',
            );
            return false;
        }

        return true;
    }

    private validateSourceOnly(): boolean {
        const { SourceOfWealth, SourceOfFunds } =
        this.$store.state.dueDiligence.details;

        const validations = [
            validate(SourceOfWealth, SourceSchema),
            validate(SourceOfFunds, SourceSchema),
        ];

        const firstError = validations.find(v => v.error);

        if (firstError?.error) {
            const message =
            firstError.error.details?.[0]?.message ??
            'At least one source is required';

            this.$store.commit('addError', message);
            return false;
        }

        return true;
    }
}
